<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="search">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-search"></i> Pesquisar
                        </div>
                        <div class="card-block">
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>País*</label>
                                    <select-api
                                        v-model="filter.id_pais"
                                        :endpoint="'/pais/pesquisa'"
                                        :opt-text="'nome'"
                                        :select-option="true"
                                    ></select-api>
                                </div>

                                <div class="col-md-4">
                                    <label>Tipo*</label>
                                    <Select2
                                        placeholder="Selecione"
                                        v-model="filter.tipo"
                                        :options="tipos"
                                        opt-id="tipo"
                                    >
                                        <option value selected>Selecione</option>
                                    </Select2>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4 col-xs-12">
                                    <label>Nome</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="filter.nome"
                                    />
                                </div>
                                <div class="col-md-4 col-xs-12">
                                    <label>Estado*</label>
                                    <dw-select
                                        :options="states"
                                        v-model="filter.id_estado"
                                        opt-text="nome"
                                        placeholder="Selecione um estado"
                                        @change="listCities()"
                                    >
                                        <option value="0" selected>Selecione um estado</option>
                                    </dw-select>
                                </div>

                                <div class="col-md-4 col-xs-12">
                                    <label>Cidade*</label>
                                    <dw-select
                                        :options="cities"
                                        v-model="filter.id_cidade"
                                        opt-text="nome"
                                        placeholder="Selecione uma cidade"
                                    >
                                        <option value="0" selected>Selecione uma cidade</option>
                                    </dw-select>
                                </div>
                            </div>

                            <hr />
                        </div>
                        <div class="card-footer">
                            <div class="form-group row">
                                <div class="col-md-6 text-left">
                                    <button type="button" @click="create" class="btn btn-primary">
                                        Nova Credenciada
                                        <i class="fa fa-angle-right"></i>
                                    </button>
                                </div>
                                <div class="col-md-6 text-right">
                                    <button
                                        type="button"
                                        @click="clean"
                                        class="btn btn-primary"
                                    >Limpar</button>
                                    <button type="submit" class="btn btn-default">
                                        <i class="fa fa-search"></i> Pesquisar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <dw-table-header :size="size" @finish="updateSize" :pagination="list"></dw-table-header>
                    </div>
                    <div class="card-block">
                        <table class="table table-bordered table-striped table-md">
                            <dw-table-head :headers="headers" :editable="true" @update="sort"></dw-table-head>
                            <tbody>
                                <tr v-for="item in list.rows">
                                    <td :data-label="headers[0].name">{{ item.id }}</td>
                                    <td :data-label="headers[1].name">{{item.nome}}</td>
                                    <td :data-label="headers[2].name">{{item.telefone}}</td>
                                    <td :data-label="headers[3].name">
                                      {{ item.endereco ? item.endereco.cidade.nome : '' }}
                                    </td>
                                    <td
                                        :data-label="headers[4].name"
                                    >{{ item.endereco ? item.endereco.cidade.estado.uf : '' }}</td>
                                    <td
                                        :data-label="headers[5].name"
                                    >{{ item.endereco ? item.endereco.cidade.estado.pais.codigo : '' }}</td>

                                    <td>
                                        <button class="btn btn-primary btn-sm" @click="edit(item.id)">
                                            <i class="fa fa-edit"></i>
                                        </button>
                                        <button class="btn btn-danger btn-sm" @click="remove(item.id)">
                                            <i class="fa fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <dw-pagination
                            :pagination="list"
                            :page="page"
                            @update="fetchData"
                            :offset="size"
                        ></dw-pagination>
                    </div>
                </div>
            </div>
            <!--/.col-->
        </div>
        <!--/.row-->
    </div>
</template>

<script>
import {
    isUndefinedOrNullOrEmpty,
    clearCpfCnpj,
    clearPhone,
    formatPhone,
    formatCpf
} from "@/services/string";
import SelectClient from "../../components/Input/SelectClient";
import Select from "../../components/Input/Select";
import SelectApi from "../../components/Input/SelectApi";
import Select2 from '../../components/Input/Select2';
import Collections from "@/helpers/collections";
import Facade from "../../facade/facade";
const facade = new Facade();

export default {
    components: { SelectClient, SelectApi, Select, Select2 },
    data() {
        return {
            headers: [
                { name: "Cód.", key: "id" },
                { name: "Nome", key: "nome" },
                { name: "Telefone", key: "telefone" },
                { name: "Cidade", key: "`endereco.cidade.nome`" },
                { name: "Estado", key: "`endereco.cidade.estado.uf`" },
                { name: "País", key: "`endereco.cidade.estado.pais.codigo`" },
            ],
            list: {},
            filter: {
                nome: null,
                id_cidade: null,
                id_estado: null,
                id_pais: '',
                tipo: ''
            },
            size: 20,
            page: 0,
            order: ["id", "ASC"],
            model: {},
            states: [],
            cities: [],
            tipos: Collections.tipoClinica
        };
    },
    computed: {
        isAdmin() {
            return facade.isAdmin();
        }
    },
    methods: {
        sort(data) {
            this.order = [data.key, data.direction];
            this.fetchData(this.page);
        },
        clean() {
            this.filter = {
                nome: null
            };
        },
        create() {
            this.$router.push({ name: "new-clinic" });
        },

        edit(id) {
            this.$router.push({ name: "edit-clinic", params: { id: id } });
        },
        remove(id) {
            this.$swal({
                title: "Você tem certeza?",
                text: "Não será possível  reverter esta operação",
                showCancelButton: true,
                confirmButtonText: "Sim, deletar!",
                cancelButtonText: "Não, cancelar!"
            }).then(
                () => {
                    this.$loading.show(true);

                    let ret = facade.deleteClinic(
                        id,
                        this.$route.params.idCliente
                    );
                    ret.then(response => {
                        this.$notify.success(
                            "",
                            "Registro removido com sucesso."
                        );
                        this.fetchData(0);
                        this.$loading.show(false);
                    }).catch(e => {
                        this.$notify.error(
                            "Erro!",
                            "Ocorreu um problema ao deletar Clinica."
                        );
                        this.$loading.show(false);
                    });
                },
                dismiss => {}
            );
        },

        fetchData(page) {
            let vm = this;
            vm.page = page;

            let params = {
                params: {
                    page: page,
                    size: vm.size,
                    order: vm.order,
                    id_cidade: "",
                    id_estado: ""
                }
            };
            for (let key in this.filter) {
                if (this.filter.hasOwnProperty(key)) {
                    params["params"][key] = this.filter[key];
                }
            }

            this.$loading.show(true);
            let ret = facade.listClinic(params);
            ret.then(response => {
                vm.list = response.data.data;
                this.$loading.show(false);
            }).catch(e => {
                this.$notify.error(
                    "Erro!",
                    "Ocorreu um problema ao listar as clinicas."
                );
                this.$loading.show(false);
            });
        },
        search() {
            this.fetchData(0);
        },
        updateSize(value) {
            let vm = this;
            vm.size = value;
            this.fetchData(0);
        },
        listCities() {
            let vm = this;
            vm.cities = [];
            vm.filter.id_cidade = 0;
            this.$loading.show(true);

            let params = { params: { id_estado: vm.filter.id_estado } };

            let ret = facade.listCity(params);
            ret.then(response => {
                vm.cities = response.data.data;
                this.$loading.show(false);
            }).catch(e => {
                this.$notify.error(
                    "Erro!",
                    "Ocorreu um problema ao listar as cidades."
                );
                this.$loading.show(false);
            });
        }
    },
    beforeMount() {
        this.fetchData(0);
        const vm = this;
        facade.listState().then(response => {
            vm.states = response.data.data;
            this.listCities();
        });
    }
};
</script>



// WEBPACK FOOTER //
// List.vue?4cb26ed6